import '../App.css'
import { Nav } from 'react-bootstrap';
import { Navbar } from 'react-bootstrap';
import logo from '../components/logo.PNG';
import Header from '../components/Header';
import { Route,Switch,Link} from 'react-router-dom';
import About from '../components/About';
import Contact from '../components/Contact';
export default function Appe() {
 return (
   <>
   
    <Navbar   expand="lg" bg="dark" variant="dark">
    <img src={logo} id="logo" alt="logo.."/>
     <Navbar.Toggle  id="toggle-button" aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
         <Nav  className="ms-auto">
         <Link to="/" className="navitems">Home</Link>
        <Link to="/about" className="navitems">About</Link>
        <Link to="/contact" className="navitems">Contact</Link>   
        </Nav> 
    </Navbar.Collapse>
    
 </Navbar>

 <Switch>
  <Route   exact path='/' component={Header}/>
  <Route   path='/about' component={About}/>
  <Route   path='/contact' component={Contact}/>
  </Switch>  
 
  

 
 

 </>
  )
}
